export default {
  sky: {
    // Scale factor that determines how much the image moves with the mouse.
    // 0.1 = image is 10% larger than the viewport
    ratio: 0.1,
    // How much the image should shift to the left or right when the browser
    // window gets narrow. This is currently only used to keep the ferns
    // out of the way on small windows.
    responsiveOffsetX: 1,
    l: {
      sharp: './assets/home/sky_2040x1148.jpg',
      blurred: './assets/home/sky-blurred_2040x1148.jpg',
      width: 2040,
      height: 1148
    },
    m: {
      sharp: './assets/home/sky_1820x1024.jpg',
      blurred: './assets/home/sky-blurred_1820x1024.jpg',
      width: 1820,
      height: 1024
    },
    s: {
      sharp: './assets/home/sky_1191x670.jpg',
      blurred: './assets/home/sky-blurred_1191x670.jpg',
      width: 1191,
      height: 670
    },
    xs: {
      sharp: './assets/home/sky_1013x570.jpg',
      blurred: './assets/home/sky-blurred_1013x570.jpg',
      width: 1013,
      height: 570
    }
  },
  mountain: {
    ratio: 0.2,
    responsiveOffsetX: 1,
    l: {
      sharp: './assets/home/mountain_2040x1148.png',
      blurred: './assets/home/mountain-blurred_2040x1148.png',
      width: 2040,
      height: 1148
    },
    m: {
      sharp: './assets/home/mountain_1820x1024.png',
      blurred: './assets/home/mountain-blurred_1820x1024.png',
      width: 1820,
      height: 1024
    },
    s: {
      sharp: './assets/home/mountain_1191x670.png',
      blurred: './assets/home/mountain-blurred_1191x670.png',
      width: 1191,
      height: 670
    },
    xs: {
      sharp: './assets/home/mountain_1013x570.png',
      blurred: './assets/home/mountain-blurred_1013x570.png',
      width: 1013,
      height: 570
    }
  },
  foregroundLeft: {
    ratio: 0.5,
    responsiveOffsetX: 0.5,
    l: {
      sharp: './assets/home/foreground-left_2040x1148.png',
      blurred: './assets/home/foreground-left-blurred_2040x1148.png',
      width: 2040,
      height: 1148
    },
    m: {
      sharp: './assets/home/foreground-left_1820x1024.png',
      blurred: './assets/home/foreground-left-blurred_1820x1024.png',
      width: 1820,
      height: 1024
    },
    s: {
      sharp: './assets/home/foreground-left_1191x670.png',
      blurred: './assets/home/foreground-left-blurred_1191x670.png',
      width: 1191,
      height: 670
    },
    xs: {
      sharp: './assets/home/foreground-left_1013x570.png',
      blurred: './assets/home/foreground-left-blurred_1013x570.png',
      width: 1013,
      height: 570
    }
  },
  foregroundRight: {
    ratio: 0.5,
    responsiveOffsetX: 0.5,
    l: {
      sharp: './assets/home/foreground-right_2040x1148.png',
      blurred: './assets/home/foreground-right-blurred_2040x1148.png',
      width: 2040,
      height: 1148
    },
    m: {
      sharp: './assets/home/foreground-right_1820x1024.png',
      blurred: './assets/home/foreground-right-blurred_1820x1024.png',
      width: 1820,
      height: 1024
    },
    s: {
      sharp: './assets/home/foreground-right_1191x670.png',
      blurred: './assets/home/foreground-right-blurred_1191x670.png',
      width: 1191,
      height: 670
    },
    xs: {
      sharp: './assets/home/foreground-right_1013x570.png',
      blurred: './assets/home/foreground-right-blurred_1013x570.png',
      width: 1013,
      height: 570
    }
  },
}
